var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "169px",
    height: "81px",
    viewBox: "0 0 169 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-1.52655666e-15 0 168.60197 0 168.60197 80.191 -1.52655666e-15 80.191"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 167.84 0 167.84 29.3545675 0 29.3545675"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loading-",
    transform: "translate(-228.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clouds",
    transform: "translate(192.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-1",
    transform: "translate(120.300985, 539.095500) scale(-1, 1) translate(-120.300985, -539.095500) translate(36.000000, 499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0230703344,58.6523 C-0.820929666,44.4023 21.7730703,48.1523 21.7730703,48.1523 C21.7730703,48.1523 15.0230703,25.1523 53.7730703,33.4023 C53.7730703,33.4023 55.5230703,15.9023 72.7730703,25.6523 C72.7730703,25.6523 102.44407,-12.3477 135.52307,4.1523 C168.602444,20.6523 153.27307,51.1523 153.27307,51.1523 C153.27307,51.1523 167.27307,49.4023 168.52307,58.6523 C169.77307,67.9023 156.27307,78.6523 127.02307,69.1523 C127.02307,69.1523 122.79007,76.9853 108.54007,76.7353 C94.2900703,76.4853 86.0230703,67.1523 86.0230703,67.1523 C86.0230703,67.1523 80.5230703,75.1523 65.5230703,70.1523 C65.5230703,70.1523 56.6230703,92.4023 24.2730703,70.6523 C24.2730703,70.6523 0.867070334,72.9023 0.0230703344,58.6523",
    id: "Fill-1",
    fill: "#5082F2",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.149370, 50.836432)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,12.2558675 C164.93,19.9758675 151.47,26.3058675 126.87,18.3158675 C126.87,18.3158675 122.64,26.1458675 108.39,25.8958675 C94.14,25.6458675 85.87,16.3158675 85.87,16.3158675 C85.87,16.3158675 80.37,24.3158675 65.37,19.3158675 C65.37,19.3158675 56.47,41.5658675 24.12,19.8158675 C24.12,19.8158675 1.99,21.9458675 0,8.95586751 C0.29,9.44586751 7.58,19.5038675 25.71,13.5658675 C34.84,20.5658675 54.423,26.3598675 73.59,2.14886751 C73.59,2.14886751 72.765,11.0798675 78.771,12.0538675 C84.777,13.0268675 90.923,9.85986751 96.34,1.02686751 C96.15,1.54686751 96.673,4.94286751 93.007,12.4428675 C93.007,12.4428675 107.534,20.2528675 118.062,10.0448675 C128.59,-0.164132494 133.09,-2.80713249 132.757,3.10986751 C132.423,9.02686751 133.835,14.9408675 146.965,10.6908675 C149.965,17.4408675 161.33,17.3158675 167.84,12.2558675",
    id: "Fill-4",
    fill: "#426BC8",
    mask: "url(#mask-4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud-1.7ab09588974e3d3e491453aff0f5908f.svg";
export { ForwardRef as ReactComponent };